export default function Noise() {
  return <div className="grain" aria-hidden="true" />;
}
